import { Flow } from '../util/Types/Flow';
import { Folder } from '../util/Types/Folder';
import { IGetAllResponse, IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export interface IFolderBatchDetailsPayload {
  folders: Record<string, Folder>;
}
// import { User } from '../Utilis/Types/User';
export class FolderService extends ApiService {
  static pathName = '/folder';

  static getFolders = (params?: {
    nested?: boolean;
  }): Promise<IGetAllResponse<any>> => {
    const query = params?.nested ? '?nested=true' : '';
    return ApiService.get(`${this.pathName}${query}`);
  };

  static getOne = (id: string): Promise<IGetOneResponse<Folder>> => {
    return ApiService.get(`${this.pathName}/${id}`);
  };

  static getBatchDetails = (
    ids: string[],
  ): Promise<IGetOneResponse<IFolderBatchDetailsPayload>> => {
    return ApiService.post(`${this.pathName}/batch-details`, { ids });
  };

  static createFolder = (body: {
    name: string;
    index?: number;
    section?: 'agents' | 'data';
    parentId?: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}`, body);
  };

  static createFolderOnSpace = (body: {
    name: string;
    index?: number;
    spaceId: string;
    section?: 'agents' | 'data';
    parentId?: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}`, body);
  };

  static ensureFolder = (body: {
    name: string;
    spaceId?: string;
  }): Promise<IGetOneResponse<Folder>> => {
    return ApiService.post(`${this.pathName}/ensure`, body);
  };

  static createSubFolder = (
    folderId: any,
    nestedFolderId: any,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/add-folder?folderId=${folderId}&nestedFolderId=${nestedFolderId}`,
    );
  };

  static addFlow = (
    folderId: string,
    flowId: string,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/add-flow?folderId=${folderId}&flowId=${flowId}`,
    );
  };

  static updateFolder = (
    id: string,
    body: {
      name?: string;
      index?: number;
      spaceId?: string;
      companyId?: string;
      parentId?: string | null;
    },
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.patch(`${this.pathName}/${id}`, body);
  };

  static updateOrder = (body: any): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/update-order`, body);
  };

  static deleteFolder = (id: string) => {
    return ApiService.delete(`${this.pathName}/${id}`);
  };
}
